import { atom } from 'jotai';
import { User as FrontEggUser } from '@frontegg/redux-store/auth/interfaces';
import { getForesightStore } from '../../util/jotai-store';

// Prefer using useCurrentUser hook, this hook should only be used when auth
// information is required.
export const authenticatedUserState = atom<FrontEggUser | undefined>(undefined);

/** The access token Frontegg issued, from before its user object arrives (see `startEarlyBoot`). */
export const earlyAccessTokenState = atom<string | undefined>(undefined);

export const sessionExpiredState = atom<boolean>(false);

/** The customer tenant this host belongs to, once the account switcher has
 *  resolved it. The assistant is shared across customers and routes by this
 *  value, so a parent-account user reaches the customer they are working in
 *  rather than the token's own tenant. */
export const customerTenantIdState = atom<string | undefined>(undefined);

/** Reads the customer tenant outside React, for request interceptors and the
 *  chat socket. */
export function readCustomerTenantId(): string | undefined {
  return getForesightStore().get(customerTenantIdState);
}

/** The token requests carry: the user's once it has loaded, including after a renewal, and the early one before. */
export function readAccessToken(store = getForesightStore()): string {
  return store.get(authenticatedUserState)?.accessToken ?? store.get(earlyAccessTokenState) ?? '';
}

/** Resolves once Frontegg's user object is in the store, or after `timeoutMs` so nothing waits forever. */
export function whenUserLoaded(store = getForesightStore(), timeoutMs = 15_000): Promise<void> {
  if (store.get(authenticatedUserState)) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    const done = () => {
      unsubscribe();
      clearTimeout(timer);
      resolve();
    };
    const unsubscribe = store.sub(authenticatedUserState, () => {
      if (store.get(authenticatedUserState)) {
        done();
      }
    });
    const timer = setTimeout(done, timeoutMs);
  });
}
